// Animação "produto voando até a sacola" ao clicar em comprar.
// Escuta o mesmo evento que o bag-drawer (publicado pelo buy-button só quando o tamanho é válido).
(function () {
  const DURATION = 600;
  // o compre junto sai do pop-up, perto do topo: com o voo curto, 600ms passa rápido demais
  const BUY_TOGETHER_DURATION = 950;
  const THUMB_SIZE = 260;
  const END_SIZE = 34;

  let lastBuyButton = null;
  let lastButtonRect = null;
  let lastClickAt = 0;

  document.addEventListener(
    "click",
    (event) => {
      // botão principal, barra fixa (<buy-button>) ou o botão do compre junto
      const button = event.target.closest?.("buy-button, buy-together [data-buy-button]");
      if (!button) return;
      lastBuyButton = button;
      // mede já no clique: o compre junto troca o botão pelo loading (display: none) antes de publicar
      lastButtonRect = button.getBoundingClientRect();
      lastClickAt = Date.now();
    },
    true,
  );

  function isVisible(el) {
    const rect = el.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  }

  function visibleArea(rect) {
    const w = Math.min(rect.right, innerWidth) - Math.max(rect.left, 0);
    const h = Math.min(rect.bottom, innerHeight) - Math.max(rect.top, 0);
    return w > 0 && h > 0 ? w * h : 0;
  }

  // imagem do produto que mais aparece na tela agora; sem nenhuma visível, usa a mais próxima do centro
  function findProductImage() {
    const images = Array.from(
      document.querySelectorAll("img.product-image, product-media-galery .embla__slide img"),
    ).filter((img) => {
      const rect = img.getBoundingClientRect();
      return rect.width > 50 && rect.height > 50 && (img.currentSrc || img.src);
    });

    let best = null;
    let bestArea = 0;
    images.forEach((img) => {
      const area = visibleArea(img.getBoundingClientRect());
      if (area > bestArea) {
        best = img;
        bestArea = area;
      }
    });
    if (best && bestArea > 5000) return { img: best, onScreen: true };

    // fora da tela (ex.: barra fixa depois de rolar): pega a imagem mais próxima do centro horizontal
    const centerX = innerWidth / 2;
    images.sort((a, b) => {
      const ra = a.getBoundingClientRect();
      const rb = b.getBoundingClientRect();
      const da = Math.abs(ra.left + ra.width / 2 - centerX);
      const db = Math.abs(rb.left + rb.width / 2 - centerX);
      return da - db || ra.top - rb.top;
    });
    return images[0] ? { img: images[0], onScreen: false } : null;
  }

  function findBag() {
    return Array.from(document.querySelectorAll("[data-button-bag]")).find(isVisible);
  }

  function bumpBag() {
    const bag = findBag();
    if (!bag) return;
    bag.animate(
      [
        { transform: "scale(1) rotate(0)" },
        { transform: "scale(1.3) rotate(-10deg)", offset: 0.3 },
        { transform: "scale(0.92) rotate(6deg)", offset: 0.55 },
        { transform: "scale(1.08) rotate(-3deg)", offset: 0.8 },
        { transform: "scale(1) rotate(0)" },
      ],
      { duration: 550, easing: "ease-out" },
    );

    const rect = bag.getBoundingClientRect();
    const ring = document.createElement("div");
    const size = Math.max(rect.width, rect.height);
    Object.assign(ring.style, {
      position: "fixed",
      left: `${rect.left + rect.width / 2 - size / 2}px`,
      top: `${rect.top + rect.height / 2 - size / 2}px`,
      width: `${size}px`,
      height: `${size}px`,
      borderRadius: "50%",
      border: "2px solid #03A079",
      pointerEvents: "none",
      zIndex: "2147483647",
    });
    document.body.appendChild(ring);
    ring
      .animate(
        [
          { transform: "scale(0.6)", opacity: 0.9 },
          { transform: "scale(1.9)", opacity: 0 },
        ],
        { duration: 600, easing: "ease-out" },
      )
      .finished.finally(() => ring.remove());
  }

  // enquanto voa, o sticky-header.js não esconde o header mesmo se o cliente rolar pra baixo
  function lockHeader() {
    document.documentElement.setAttribute("data-header-locked", "");
  }

  function unlockHeader() {
    document.documentElement.removeAttribute("data-header-locked");
  }

  // o sticky-header.js esconde o header ao rolar pra baixo: mostra de novo pra sacola ficar visível
  function revealHeader() {
    const hidden = document.querySelectorAll(".sticky-element.is-hidden");
    if (!hidden.length) return Promise.resolve();

    hidden.forEach((el) => el.classList.remove("is-hidden"));

    // com a sacola/modal aberto o sticky-header ignora o scroll, então esconde no próximo scroll pra baixo
    let lastY = window.scrollY;
    const hideAgain = () => {
      if (
        document.documentElement.hasAttribute("data-header-locked") ||
        document.querySelector('[data-drawer="true"]') ||
        document.body.style.overflow === "hidden"
      ) {
        lastY = window.scrollY;
        return;
      }
      if (window.scrollY > lastY + 8) {
        hidden.forEach((el) => el.classList.add("is-hidden"));
        window.removeEventListener("scroll", hideAgain);
      }
      lastY = window.scrollY;
    };
    setTimeout(() => window.addEventListener("scroll", hideAgain, { passive: true }), DURATION);

    return new Promise((resolve) => setTimeout(resolve, 350));
  }

  // compre junto: as peças escolhidas voam a partir do botão do próprio compre junto
  function findBuyTogetherImages(button) {
    const container = button.closest("buy-together");
    if (!container) return [];
    return Array.from(container.querySelectorAll("[data-product-id] img"))
      .filter((img) => img.currentSrc || img.src)
      .slice(0, 3)
      .map((img) => img.currentSrc || img.src);
  }

  async function fly(data) {
    if (matchMedia("(prefers-reduced-motion: reduce)").matches) return;

    // posição da imagem/botão é medida antes do header descer; a da sacola, depois
    const recentButton =
      lastBuyButton && Date.now() - lastClickAt < 1000 ? lastBuyButton : null;
    const isBuyTogether = !!(data?.buyTogether && recentButton?.closest("buy-together"));
    const found = isBuyTogether ? null : findProductImage();
    const image = found?.img;
    const imageSrcs = isBuyTogether
      ? findBuyTogetherImages(recentButton)
      : image ? [image.currentSrc || image.src] : [];
    const imageRect = found?.onScreen ? image.getBoundingClientRect() : null;
    const buttonRect = recentButton ? lastButtonRect : null;

    // o pop-up do compre junto é um <dialog> modal (top layer): fecha antes, senão o voo fica atrás dele
    const dialog = recentButton?.closest("dialog[open]");
    if (dialog) dialog.close("opening-bag");

    lockHeader();
    try {
      await revealHeader();

      const bag = findBag();
      if (!bag) return;

      await Promise.all(
        (imageSrcs.length ? imageSrcs : [null]).map((src, index) =>
          wait(index * 110).then(() =>
            flyOne({
              src,
              index,
              recentButton,
              buttonRect,
              imageRect,
              bag,
              duration: isBuyTogether ? BUY_TOGETHER_DURATION : DURATION,
            }),
          ),
        ),
      );
    } finally {
      unlockHeader();
    }
  }

  function wait(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  function flyOne({ src: image, index, recentButton, buttonRect, imageRect, bag, duration }) {
    // origem: quadrado no centro da imagem visível, ou o próprio botão como fallback
    let startRect;
    if (recentButton) {
      // sai do botão clicado (normal, fixo ou compre junto); a foto do produto só fornece a imagem.
      // várias peças saem levemente lado a lado
      const r = buttonRect;
      const size = image ? 120 : Math.min(r.height, 56);
      const spread = [0, 28, -28][index] || 0;
      startRect = {
        left: r.left + r.width / 2 - size / 2 + spread,
        top: r.top + r.height / 2 - size / 2,
        size,
      };
    } else if (imageRect) {
      const r = imageRect;
      const size = Math.min(THUMB_SIZE, r.width, r.height);
      const cx = Math.max(r.left, 0) + (Math.min(r.right, innerWidth) - Math.max(r.left, 0)) / 2;
      const cy = Math.max(r.top, 0) + (Math.min(r.bottom, innerHeight) - Math.max(r.top, 0)) / 2;
      startRect = { left: cx - size / 2, top: cy - size / 2, size };
    } else {
      return Promise.resolve();
    }

    const bagRect = bag.getBoundingClientRect();
    const dx = bagRect.left + bagRect.width / 2 - (startRect.left + startRect.size / 2);
    const dy = bagRect.top + bagRect.height / 2 - (startRect.top + startRect.size / 2);
    const endScale = END_SIZE / startRect.size;

    // wrapper anima o X, inner anima o Y + escala: easings diferentes desenham um arco
    const wrapper = document.createElement("div");
    Object.assign(wrapper.style, {
      position: "fixed",
      left: `${startRect.left}px`,
      top: `${startRect.top}px`,
      width: `${startRect.size}px`,
      height: `${startRect.size}px`,
      pointerEvents: "none",
      zIndex: "2147483647",
    });

    const inner = document.createElement("div");
    Object.assign(inner.style, {
      width: "100%",
      height: "100%",
      overflow: "hidden",
      borderRadius: "12px",
      boxShadow: "0 12px 30px rgba(0, 0, 0, 0.35)",
      background: image ? "#fff" : "#03A079",
    });

    if (image) {
      const clone = document.createElement("img");
      clone.src = image;
      Object.assign(clone.style, { width: "100%", height: "100%", objectFit: "cover" });
      inner.appendChild(clone);
    }

    wrapper.appendChild(inner);
    document.body.appendChild(wrapper);

    const options = { duration, fill: "forwards" };

    wrapper.animate(
      [{ transform: "translateX(0)" }, { transform: `translateX(${dx}px)` }],
      { ...options, easing: "cubic-bezier(0.55, 0, 0.85, 0.5)" },
    );

    // o balanço da sacola começa um pouco antes do pouso, para o fim do voo não "morrer" no ar
    const bumpTimer = index === 0 ? setTimeout(bumpBag, duration * 0.85) : null;

    // o fade usa easing linear próprio: com o easing do voo a miniatura sumiria antes de chegar
    inner.animate(
      [{ opacity: 1 }, { opacity: 1, offset: 0.8 }, { opacity: 0 }],
      { ...options, easing: "linear" },
    );

    return inner.animate(
      [
        { transform: "translateY(0) scale(1)", borderRadius: "12px" },
        { transform: "translateY(0) scale(1.08)", offset: 0.12 },
        {
          transform: `translateY(${dy}px) scale(${endScale})`,
          borderRadius: `${startRect.size / 2}px`,
        },
      ],
      { ...options, easing: "cubic-bezier(0.25, 0.8, 0.4, 1)" },
    ).finished.then(
      () => wrapper.remove(),
      () => {
        clearTimeout(bumpTimer);
        wrapper.remove();
      },
    );
  }

  // o bag-drawer espera essa promise antes de abrir a sacola, para ela não abrir no meio do voo
  subscribe(PUB_SUB_EVENTS.clickBuyButton, (data) => {
    window.flyToBagPending = fly(data).catch(() => {});
  });
})();
